import { Box, Grid, IconButton, Tooltip } from '@mui/material'
import { useQueries, useQuery } from '@tanstack/react-query'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import WrapperWithHeader from 'components/wrapper-with-header'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import ProjectListCard from 'pages/automation/project/list/card'
import CardSkelleton from 'pages/automation/project/list/card-skelleton'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { loadItem, loadList } from 'services/requests'
import useContract from 'store/contracts'
import extractState from 'utils/organization/extract-state'
import ContractViewHeader from './header'
import { useStyles } from './styles'
import api from 'services/api'
import { AccountTreeRounded } from '@mui/icons-material'
import MovimentacaoPending from './movimentacao/movimentacaoPending'
import { useAuth } from 'contexts/auth'
import FeedIcon from '@mui/icons-material/Feed';

interface IRouteParams {
  organizationId: string
  contractId: string
  tagId: string
}

export interface IMovimentacaoResponse {
    result: {
        movimentacao: string; //"Inclusão" | "Demissão" | "Transferência" | "Alteração";
        cpf: string;
        cpfDependente: string;
        nome: string;
        parentesco: string; //"Titular" | "Dependente";
        plano: string;
        cargo: string;
        dataAdmissao: string;
        dataDemissao: string;
        municipio: string;
        registrationNumber: string;
    }[],
    //metrics: { title: "Total" | "Inclusões" | "Exclusões" | "Alterações" | "Transferências", value: number }[],
    metrics: {
        "total": number,
        "Inclusão": number,
        "Demissão": number,
        "Alteração": number,
        "Transferência": number
    },
    executionDate: string; //ideally should be of Date type.
    approvalDate: string;
}

const ContractView = () => {
  const { actualOrganization, updateOrganization, setRollbackUrl, contractTagName, viewMode, updateViewMode } = useContract();
  const { organizationId, contractId, tagId } = useParams<IRouteParams>();
  const { user } = useAuth();

  // const [viewMode, setViewMode] = useState<'table' | 'grid'>('table');

  const classes = useStyles();

  const [organizationQuery, projectsQuery] = useQueries({
    queries: [
      {
        queryKey: ['contracts', 'organization', organizationId],
        queryFn: () => loadItem('/organizations', organizationId),
        enabled: actualOrganization.id == undefined && !!organizationId,
      },
      {
        queryKey: ['contracts', 'list', 'project', organizationId, contractId, tagId],
        queryFn: () =>
          loadList('/projects/list', {
            search: '',
            page: 0,
            rowsPerPage: 100,
            columnOrder: [],
            organizationId: organizationId,
            contractId: contractId,
            tagId: tagId,
          }),
        initialData: { data: { data: [] } } as any,
      },
    ],
  });

  // Só deve fazer essa chamada quando tabela existir e não estourar erro.
  // Pode até fazer, caso dê algum erro, retorna dados vazios.
  const { data: movimentacao, isFetched: isMovimentacaoFetched, isFetching: isMovimentacaoFetching } = useQuery({
    queryKey: ['brb'],
    queryFn: () => api.get<{ data: IMovimentacaoResponse }>(`/projects/list-movimentacao/${projectsQuery.data?.data?.data?.[0]?.organizationOutput?.id}/${contractId}`),
    select: (data) => data?.data?.data ?? null,
    initialData: null,
    enabled: !!actualOrganization.id && !!organizationId && !!projectsQuery.data?.data?.data?.[0]?.organizationOutput?.id, //Nunca terá em dev pois mocka
  });

//   const projectzz = projectsQuery?.data?.data?.data?.find((project: any) => project.name === 'Minhas compras')?.id;
//   const aki = projectzz?.entryTables?.[0]
//   console.log("Ver se é esse >> ", projectsQuery?.data?.data?.data?.find((project: any) => project.name === 'Minhas compras'))
  const { data: purchasesProject } = useQuery({
    queryKey: ['brb2'],
    queryFn: () => api.get<{ data: any }>(`/projects/${projectsQuery?.data?.data?.data?.find((project: any) => project.name === 'Minhas compras')?.id}`),
    enabled: !!projectsQuery?.data?.data?.data?.find((project: any) => project.name === 'Minhas compras')?.id
  });

//   console.log("Feita a query...", purchasesProject?.data?.data?.entryTables[0].key);

    const purchase = purchasesProject?.data?.data;
    //@ts-ignore
    // const purchase = mockSaude.data;

    const projects: IProjectDTO[] = projectsQuery.data?.data.data;
    //   @ts-ignore
    // const projects = projectsMock.data as IProjectDTO[];

    const projectFound = projects?.find((project: any) => project.name === 'Minhas compras');
    if(projectFound?.entryTables && !!purchase?.entryTables) {
        //@ts-ignore
        projectFound.entryTables = [...purchase.entryTables];
    }
    const finalProjects = projectFound ? projects.map(proj => {
        if(proj.name === 'Minhas compras') return projectFound
        return proj
    }) : projects


    useEffect(() => {
        if (isMovimentacaoFetched && !movimentacao) updateViewMode('grid');
    }, [isMovimentacaoFetched]);

  function handleChangeStepper(step: number) {}

  useEffect(() => {
    if (organizationQuery.data && actualOrganization.id == undefined) {
      const organizationState = extractState(organizationQuery.data?.data.data)
      updateOrganization(organizationState)
    }

    if (organizationId && contractId && tagId) {
      setRollbackUrl(`/contract/movimentacao/${organizationId}/${contractId}/${tagId}`)
    }
  }, [organizationQuery.data, organizationId, contractId, tagId]);

  if (organizationQuery.isLoading || actualOrganization.id == undefined) {
    return (
      <WrapperWithHeader>
        <Loading />
      </WrapperWithHeader>
    )
  }

  if (projectsQuery.isLoading || projectsQuery.isFetching || isMovimentacaoFetching) {
    return (
      <Wrapper>
        <Header />
        <Page>
          <Box className={classes.container}>
            <Grid
              container
              spacing={3}
              className={classes.itemList}
            >
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
            </Grid>
          </Box>
        </Page>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={contractTagName}
          backRoute={`/contract/${actualOrganization!.id}/${contractId}`}
        />
        <HeaderModule.tabs
          current={0}
          options={['Atividades', 'Histórico', 'Contrato']}
          onChange={() => {}}
          moduleName='contract view'
        />
        {/* <ContractViewHeader project={projects[0]} /> */}
      </Header>

      <Page>
        {viewMode === 'table' && movimentacao && (
          <MovimentacaoPending 
            organizationId={organizationId}
            //@ts-ignore
            projects={finalProjects}
            isSeller={user?.isSeller}
            handleChangeStepper={handleChangeStepper}
            ultimaAtualizacao={movimentacao.executionDate}
            approvalDate={movimentacao.approvalDate}
            dataProps={movimentacao.result}
            metrics={movimentacao.metrics}
            setViewMode={updateViewMode}
          />
        )}

        {viewMode === 'grid' && (
          <Box className={classes.container}>
            <div className='flex flex-row-reverse'>
                {movimentacao && (
                <Tooltip title='Modo Resumido'>
                    <IconButton onClick={() => updateViewMode('table')}>
                      <FeedIcon className='w-7 h-7 !text-letter/55 cursor-pointer hover:!text-letter' />
                    </IconButton>
                </Tooltip>
                )}
            </div>
            <Grid
              container
              spacing={3}
              className={classes.itemList}
            >
              {projects.map((project) => (
                <Grid
                  key={project?.id}
                  item
                  xs={6}
                >
                  <ProjectListCard 
                    organizationId={organizationId}
                    project={project}
                    contractId={contractId}
                    withoutTags
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Page>
    </Wrapper>
  )
}

export default ContractView
